export default class PlatformApiClient {

  constructor(clientId, fetch) {
    this.clientId = clientId;
    this.urlBase = process.env.PLATFORM_API.URL_BASE.EXTERNAL;
    this.fetch = fetch;
  }

  getProduct(id) {
    const url = new URL(`/cosme/v2/products/${id}`, this.urlBase);
    url.searchParams.append('client_id', this.clientId);
    url.searchParams.append('product_img_size', 'xl'); // 画像サイズ

    return (this.fetch || window.fetch)(url.href).then((response) => {
      if (!response.ok) {
        const error = new Error(response.statusText);
        error.status = response.status;
        throw error;
      }
      return response.json();
    });
  }

  getBrand(id) {
    const url = new URL(`/cosme/v1/brands/${id}`, this.urlBase);
    url.searchParams.append('client_id', this.clientId);

    return (this.fetch || window.fetch)(url.href).then((response) => {
      if (!response.ok) {
        const error = new Error(response.statusText);
        error.status = response.status;
        throw error;
      }
      return response.json();
    });
  }
}
